// extracted by mini-css-extract-plugin
export default {"holder":"Item_holder__wsbJt","show":"Item_show__zqvgj","photo":"Item_photo__VCiHs","name":"Item_name__n69NC"};